/* Fetch data from Creek /tracks API */

const events = require('../core/events');
const fetch = require('../helpers/fetch');

const showUrlBase = '/api/show/';
const broadcastingUrl = '/api/broadcasting/';

// Shows don't change often, certainly not during a browser session, so we cache
// the responses;
var showCache = {};

const shows = {
  fetch: function fetchShow(id) {
    if (Object.prototype.hasOwnProperty.call(showCache, id)) {
      document.dispatchEvent(new CustomEvent(events.dataShowInfo, {
        detail: showCache[id]
      }));
      return;
    }

    const showUrl = showUrlBase + id;
    fetch.get(showUrl, { responseType: 'json' }, {
      success: function gotShow(response) {
        showCache[id] = response;
        document.dispatchEvent(new CustomEvent(events.dataShowInfo, {
          detail: response
        }));
      },
      failure: function currentTrackFailed(e) {
        console.warn(e);
      }
    });
  },

  fetchCurrent: function fetchCurrent() {
    if (this.currentShowFromCache()) {
      return;
    }

    fetch.get(broadcastingUrl, { responseType: 'json' }, {
      success: function gotShow(response) {
        // HACK: Creek API may return `null` when no track is playing
        if (!response) { return; }

        // TODO: response.upcoming has invalid dates, so ignore
        [response.now, response.next].forEach(function (showData) {
          showCache[showData.id] = showData;
        });

        shows.fetch(response.now.id);
      },
      failure: function currentTrackFailed(e) {
        console.warn(e);
      }
    });
  },

  currentShowFromCache: function currentShowFromCache() {
    const now = new Date();
    const currentShowId = Object.keys(showCache).filter(function (id) {
      const show = showCache[id];
      if (!show || !show.Airtime) { return false; }

      const start = new Date(show.Airtime.start_date_time_gmt.replace(' ', 'T') + 'Z');
      const end = new Date(show.Airtime.end_date_time_gmt.replace(' ', 'T') + 'Z');

      return now >= start && now <= end;
    }).shift();

    if (!currentShowId) { return false; }

    this.fetch(currentShowId);
    return true;
  }
};

module.exports = shows;



//////////////////
// WEBPACK FOOTER
// ./src/js/data/creekShowsApi.js
// module id = 117
// module chunks = 1